import { useState } from "react";
import { doc, setDoc } from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import config from "@poseidon/utils/config";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";

export const useSaveTags = () => {
  const [complete, setComplete] = useState(false);
  const [saving, setSaving] = useState(false);
  const { setError } = useErrorMessage();
  const { setToast } = useToastMessage();

  const saveTags = async ({ agreementId, values }) => {
    setSaving(true);

    try {
      await setDoc(
        doc(db, config.SaltCollection.Agreement, agreementId),
        values,
        { merge: true }
      );
      setComplete(true);
      setToast("Successfully updated Agreement Tags");
    } catch (error) {
      setError(error.message);
    }

    setSaving(false);
  };
  return { saving, error: !saving && !complete, success: complete, saveTags };
};
